import { Stack, Title } from '@common/ui'
import { com } from '@eidu/web'
import SemanticLinksStack from './SemanticLinksStack'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import SemanticLink = com.eidu.entity.analytics.SemanticLink

type EntityTypesStackProps = {
  kind: EntityTypeKind
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
}

const EntityTypesStack = ({ kind, entityTypes, semanticLinks }: EntityTypesStackProps) => (
  <Stack gap={0}>
    <Title order={4}>{`${kind.toString()} Types`}</Title>
    <Stack gap="xs" py="md">
      {entityTypes.map(
        (entityType) =>
          entityType.kind.equals(kind) && (
            <SemanticLinksStack
              key={entityType.id.toString()}
              entityTypes={entityTypes}
              entityType={entityType}
              semanticLinks={semanticLinks.filter(({ path }) => path.fromType.equals(entityType.id))}
            />
          )
      )}
    </Stack>
  </Stack>
)

export default EntityTypesStack
